<div class="flex w-fit items-center gap-3">
  <h1
    class="typography-headings-small !text-common-contrast !select-none !whitespace-nowrap !capitalize"
  >
    {{ label() }}
  </h1>

  @if (showStateBadge()) {
    <ng-container
      [ngTemplateOutlet]="BadgeTemplate"
      [ngTemplateOutletContext]="{
        state: state(),
      }"
    />
  }
</div>

<ng-template #BadgeTemplate let-state="state">
  @switch (state) {
    @case ("new") {
      <ag1-badge-solid label="NEW" color="french-blue" />
    }
    @case ("beta") {
      <ag1-badge-solid label="BETA" color="slate" />
    }
    @case ("alpha") {
      <ag1-badge-solid label="ALPHA" color="slate" />
    }
  }
</ng-template>
